import { render, staticRenderFns } from "./CrisiscasesGrading.vue?vue&type=template&id=43a8b088&scoped=true"
import script from "./CrisiscasesGrading.vue?vue&type=script&lang=js"
export * from "./CrisiscasesGrading.vue?vue&type=script&lang=js"
import style0 from "./CrisiscasesGrading.vue?vue&type=style&index=0&id=43a8b088&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43a8b088",
  null
  
)

export default component.exports